import { ReactElement } from 'react';
import { Card, CardActions, CardContent } from '@mui/material';
import { DEFAULT_EC2_ROUTES } from '@localstack/constants';
import { useAwsEffect, useRoutes } from '@localstack/services';
import { CreateEC2SecurityGroupRequest } from '@localstack/types';
import { PageTitle, ProgressButton, SecurityGroupForm } from '@localstack/ui';

import { NavTabs } from './components/NavTabs';
import { EC2Props } from './types';

export const SecurityGroupCreate = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_EC2_ROUTES,
}: EC2Props): ReactElement => {
  const { goto } = useRoutes();

  const { createSecurityGroup, isLoading } = useAwsEffect('EC2', ['createSecurityGroup'], {
    revalidate: ['describeSecurityGroups'],
    clientOverrides,
  });

  const handleCreate = async (data: CreateEC2SecurityGroupRequest) => {
    const result = await createSecurityGroup(data);
    const groupId = result?.GroupId;

    if (groupId) {
      goto(routes.RESOURCES_EC2_SECURITY_GROUP, { groupId });
    }
  };

  return (
    <Layout
      documentTitle="EC2: Create Security Group"
      tabs={<NavTabs routes={routes} />}
      title={
        <PageTitle
          title="Create Security Group"
          breadcrumbs={[
            ['EC2', () => goto(routes.RESOURCES_EC2)],
            ['Security Groups', () => goto(routes.RESOURCES_EC2_SECURITY_GROUPS)],
            ['Create Security Group', null],
          ]}
        />
      }
      actions={
        <ProgressButton color="primary" variant="outlined" type="submit" form="SecurityGroupCreate" loading={isLoading}>
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <SecurityGroupForm
            formId="SecurityGroupCreate"
            onSubmit={handleCreate}
            loading={isLoading}
            clientOverrides={clientOverrides}
          />
        </CardContent>
        <CardActions>
          <ProgressButton
            color="primary"
            variant="contained"
            type="submit"
            form="SecurityGroupCreate"
            loading={isLoading}
          >
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
